module.exports = __webpack_public_path__ + "img/6.5a3906d6.jpg";